import datetime from '@/utils/datetime';

export default {
    methods: {
        ...datetime,
    },
};



// WEBPACK FOOTER //
// ./src/mixins/datetime.js